import React, { useState } from "react";

const CopyToClipboard = ({ text, children }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        onCopy(true);
      }
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error(err);
      alert("Failed to copy");
    }
  };

  return (
    <button onClick={handleCopy}>
      {copied ? "Copied" : children || "Copy"}
    </button>
  );
};

export default CopyToClipboard;
